import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { subDays, subMonths } from 'date-fns';
import { DateRange, extractDateRange, HxMoneyFormatPipe, HxReportService, HxUiLabelPipe, isoDate, StatisticsStoreSalesModel, toRouterQueryParams } from 'hx-services';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HxDateRangeSelectComponent, HxLoaderComponent } from 'hx-component';
import { FormsModule } from '@angular/forms';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-statistics-store',
    templateUrl: './store-sales.component.html',
    styleUrls: ['./store-sales.component.css'],
    imports: [HxDateRangeSelectComponent, FormsModule, NgIf, NgFor, NgClass, RouterLink, HxLoaderComponent, TranslocoPipe, HxUiLabelPipe, HxMoneyFormatPipe]
})
export class StoreSalesComponent implements OnInit, OnDestroy {
  sales: StatisticsStoreSalesModel[] = [];
  isloading = {
    sales: false,
  };
  params: {
    date?: DateRange,
  }= {};
  counter = 1;
  allStoreIds: number[] = [];
  private sub!: Subscription;

  constructor(
    private reportService: HxReportService,
    private aRoute: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.sub = this.aRoute.queryParamMap.subscribe(async paramMap => {
      this.params.date = extractDateRange('date', paramMap) ?? { from: isoDate(subDays(subMonths(new Date(), 1), 1)), to: isoDate(subDays(new Date(), 1)) };
      this.loadStoreSales();
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  applyFilters() {
    this.navigate();
  }

  private navigate() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }

  private async loadStoreSales() {
    this.sales = [];
    this.isloading.sales = true;
    try {
      const sales = await this.reportService.getStatisticsStoreSales({fromDate: this.params.date.from, toDate: this.params.date.to, storeIds: [] });
      if (sales.length > 0) {
        this.allStoreIds = sales.map(r => r.storeId);
        this.sales = sales;
      } else {
        this.sales = [];
      }
    } finally {
      this.isloading.sales = false;
    }
  }
}
